import groupBy from 'lodash.groupby';

/**
 *
 * @param grouped
 * @returns {boolean}
 */
function getFirstGroupedOrFalse(grouped) {
  return Object.keys(grouped).length === 1
    ? grouped[Object.keys(grouped)[0]][0]
    : false;
}

/**
 * @param data
 * @returns {null|Object}
 */
export default function getRedirectProps(data) {
  const redirectToUser = getFirstGroupedOrFalse(groupBy(data, 'username'));

  if (redirectToUser) {
    return {
      region: redirectToUser.region_code,
      country: redirectToUser.country,
      store: redirectToUser.store_id,
      username: redirectToUser.username,
    };
  }
  
  const redirectToStore = getFirstGroupedOrFalse(groupBy(data, 'store_id'));

  if (redirectToStore) {
    return {
      region: redirectToStore.region_code,
      country: redirectToStore.country,
      store: redirectToStore.store_id,
    };
  }

  const redirectToCountry = getFirstGroupedOrFalse(groupBy(data, 'country'));

  if (redirectToCountry) {
    return {
      region: redirectToCountry.region_code,
      country: redirectToCountry.country,
    };
  }

  const redirectToRegion = getFirstGroupedOrFalse(groupBy(data, 'region_code'));

  if (redirectToRegion) {
    return {
      region: redirectToRegion.region_code,
    };
  }

  return null;
}
